import { shortName } from '~helpers';

const workflowLink = (d, short) => {
  const text = [
    d.workflowType ? shortName(d.workflowType.name) : '',
    short ? '' : d.workflowExecution.workflowId,
  ]
    .filter(x => x)
    .join(' - ');

  return {
    routeLink: {
      name: 'workflow/summary',
      params: {
        namespace: d.namespace,
        workflowId: d.workflowExecution.workflowId,
        runId: d.workflowExecution.runId,
      },
    },
    text,
  };
};

export default workflowLink;



// WEBPACK FOOTER //
// ./client/routes/workflow/helpers/workflow-link.js